import { ArrowUpRight, Download } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, scrollToId } from "../../lib/site";

const TRAVAUX = ["Électricité", "Plomberie", "Carrelage", "Rénovation", "Travaux BTP"];

const CARDS = [
    {
        id: "materiel",
        tag: "Location",
        title: "Location de matériel de chantier",
        text: "Des solutions de location adaptées aux besoins ponctuels ou réguliers de vos chantiers. Contactez-nous pour nous préciser le matériel recherché, la durée et les contraintes de votre intervention.",
        cta: "Faire une demande",
        img: IMAGES.equipment,
        alt: "Matériel de chantier professionnel",
        testid: "solution-card-materiel",
        ctaTestid: "solution-cta-materiel",
    },
    {
        id: "vehicules",
        tag: "Véhicules",
        title: "Véhicules professionnels",
        text: "Besoin d'un véhicule dans le cadre d'un chantier ou d'une activité professionnelle ? Présentez-nous votre besoin afin que nous puissions étudier la solution disponible.",
        cta: "Nous contacter",
        img: IMAGES.vehicles,
        alt: "Véhicule utilitaire professionnel",
        testid: "solution-card-vehicules",
        ctaTestid: "solution-cta-vehicules",
    },
    {
        id: "travaux",
        tag: "Travaux",
        title: "Travaux & rénovation",
        text: "NEBOORZY intervient également dans différents domaines du bâtiment et de la rénovation, directement ou avec les compétences adaptées au chantier.",
        cta: "Décrire mon chantier",
        img: IMAGES.works,
        alt: "Travaux de rénovation intérieure",
        testid: "solution-card-travaux",
        ctaTestid: "solution-cta-travaux",
        chips: TRAVAUX,
    },
];

export const Solutions = () => (
    <section id="solutions" data-testid="solutions-section" className="bg-ink py-24 lg:py-36">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mb-14 flex flex-col gap-4 lg:mb-20 lg:flex-row lg:items-end lg:justify-between">
                <div>
                    <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-signal">
                        02 — Nos solutions
                    </p>
                    <h2 className="max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Trois pôles pour répondre à votre chantier
                    </h2>
                </div>
                <p className="max-w-sm text-sm leading-relaxed text-zinc-400 sm:text-base">
                    Un besoin précis ou un chantier global : décrivez-le nous, un commercial
                    étudie la solution avec vous.
                </p>
            </Reveal>
            <div className="grid gap-6 md:grid-cols-3">
                {CARDS.map((c, i) => (
                    <Reveal key={c.id} delay={i * 0.12}>
                        <article
                            data-testid={c.testid}
                            className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-steel transition-colors hover:border-signal/50"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={c.img}
                                    alt={c.alt}
                                    loading="lazy"
                                    className="aspect-[4/3] w-full object-cover grayscale-[40%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                                />
                                <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-signal backdrop-blur">
                                    {c.tag}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-7">
                                <h3 className="font-display text-xl font-bold text-white sm:text-2xl">
                                    {c.title}
                                </h3>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-400 sm:text-base">
                                    {c.text}
                                </p>
                                {c.chips && (
                                    <ul className="mt-4 flex flex-wrap gap-2" data-testid="solution-travaux-chips">
                                        {c.chips.map((chip) => (
                                            <li
                                                key={chip}
                                                className="rounded-full border border-white/15 px-3 py-1 text-xs font-medium text-zinc-300"
                                            >
                                                {chip}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                <button
                                    type="button"
                                    data-testid={c.ctaTestid}
                                    onClick={() => scrollToId("besoin")}
                                    className="mt-6 inline-flex items-center gap-2 self-start text-sm font-bold text-signal transition-colors hover:text-white"
                                >
                                    {c.cta}
                                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                                </button>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.15} className="mt-12 text-center">
                <a
                    data-testid="solutions-brochure-button"
                    href="/plaquette-commerciale-neboorzy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    className="group inline-flex items-center gap-2 rounded-full bg-signal px-8 py-4 text-base font-bold text-ink transition-colors hover:bg-signal-dark"
                >
                    <Download className="h-5 w-5 transition-transform group-hover:translate-y-0.5" />
                    Télécharger notre plaquette commerciale
                </a>
            </Reveal>
        </div>
    </section>
);
